/* eslint-disable object-shorthand */
const autoplay = $('#autoplay').val();
const autoplaySpeed = $('#autoplaySpeed').val();
const autoplayHeaderInfo = $('#autoplayHeaderInfo').val();
const autoplaySpeedHeaderInfo = $('#autoplaySpeedHeaderInfo').val();
const mode = $('#mode').val() !== 'slide';

module.exports = {
    slider: {
        autoplay: autoplay === 'true',
        autoplaySpeed: autoplaySpeed, // delay between transition
        autoplayHeaderInfo: autoplayHeaderInfo === 'true',
        autoplaySpeedHeaderInfo: autoplaySpeedHeaderInfo,
        fade: mode,
        infinite: false,
        vertical: false,
        rows: 1,
    },
};
